module.exports = __webpack_public_path__ + "img/pr-2.06ec50da.png";